// TSP data import/export functions
import { v4 as uuidv4 } from 'uuid';

// Define LocationType constant directly to avoid circular imports
const LocationType = {
  NORMAL: 'normal',
  START: 'start',
  END: 'end',
  WAYPOINT: 'waypoint'
};

export const exportLocationsToJson = (locations, filename = "locations.json") => {
  try {
    // build the data structure
    const exportData = {
      locations: [],
      exportTime: new Date().toISOString()
    };
    
    // process each location
    for (const loc of locations) {
      exportData.locations.push({
        id: loc.id,
        name: loc.name,
        latitude: loc.latitude,
        longitude: loc.longitude,
        type: loc.type // keep the type
      });
    }
    
    // Convert to JSON string
    const jsonString = JSON.stringify(exportData, null, 2);
    
    // Create Blob object
    const blob = new Blob([jsonString], { type: "application/json" });
    
    // Create download link
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    
    // Add to DOM, trigger download, then remove
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    // Release URL object
    URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    console.error('Failed to export location points data:', error);
    throw error;
  }
};

export const importLocationsFromJson = (file) => {
  return new Promise((resolve, reject) => {
    try {
      const reader = new FileReader();
      
      reader.onload = (event) => {
        try {
          const jsonData = JSON.parse(event.target.result);
          
          // Validate data format
          if (!jsonData.locations || !Array.isArray(jsonData.locations)) {
            throw new Error('Invalid JSON format, missing locations array');
          }
          
          // Validate each location point object
          const validatedLocations = jsonData.locations.map((loc, index) => {
            // Check required fields
            if (!loc.latitude || !loc.longitude) {
              throw new Error(`Location point ${index+1} missing required coordinate information`);
            }
            
            // Return normalized location object
            // Preserve original ID and type, use defaults if not present
            return {
              id: loc.id || uuidv4(),
              name: loc.name || `Point ${index+1}`,
              latitude: parseFloat(loc.latitude),
              longitude: parseFloat(loc.longitude),
              type: loc.type || LocationType.NORMAL // Preserve original type or use default type
            };
          });
          
          resolve(validatedLocations);
        } catch (parseError) {
          reject(parseError);
        }
      };
      
      reader.onerror = () => {
        reject(new Error('File read failed'));
      };
      
      reader.readAsText(file);
    } catch (error) {
      reject(error);
    }
  });
}; 